import { render, staticRenderFns } from "./today-commission.vue?vue&type=template&id=c3fa611c&"
import script from "./today-commission.vue?vue&type=script&lang=js&"
export * from "./today-commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports